import { Box, IconButton } from 'ui';
import { Circle } from 'ui/icons';

export const CaptureButton = ({ onClick, disabled }: { onClick: () => void; disabled: boolean }) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        border: '6px solid white',
        borderRadius: '50%',
        cursor: 'pointer',
        display: 'flex',
        height: 50,
        justifyContent: 'center',
        width: 50,
      }}
    >
      <IconButton
        sx={{ alignItems: 'center', display: 'flex', height: '100%', margin: 0, padding: 0, width: '100%' }}
        onClick={onClick}
        disabled={disabled}
      >
        <Circle sx={{ color: 'white', height: '100%', width: '100%' }} />
      </IconButton>
    </Box>
  );
};
